export default "__VITE_ASSET__ylPZGUeY__"